import React from 'react'
import { Link } from '@tanstack/react-router'
import { cn } from '@/lib/utils'

const BreadScrum = ({
  breadcrumbs,
}: {
  breadcrumbs: { link: string; label: string }[]
}) => {
  return (
    <div className={cn('relative z-10 flex flex-col justify-end')}>
      {breadcrumbs.length > 0 && (
        <nav className='mb-2 hidden text-sm font-medium capitalize md:flex md:gap-2 md:text-[13px]'>
          {breadcrumbs.map((b, idx) => (
            <React.Fragment key={b.label + idx}>
              {b.link ? (
                <Link to={b.link} className=''>
                  {b.label}
                </Link>
              ) : (
                <span className=''>{b.label}</span>
              )}
              {idx < breadcrumbs.length - 1 && <span className=''>›</span>}
            </React.Fragment>
          ))}
        </nav>
      )}
    </div>
  )
}

export default BreadScrum
